<div class="header-container">
  <div class="header-content">
    <div class="left__content w-100">
      @if (isLogoVisible) {
        @if ((userInformation | async)?.ApplicationInfo?.ApplicationHeaderLogoType !== "SVG_LOGO") {
          @if ((userInformation | async)?.ApplicationInfo?.ApplicationHeaderLogoUrl) {
            <img height="50" [src]="(userInformation | async)?.ApplicationInfo?.ApplicationHeaderLogoUrl" alt="Logo" (click)="onClickLogo()" class="cursor-pointer" />
          }
        }
        @if ((userInformation | async)?.ApplicationInfo?.ApplicationHeaderLogoType === "SVG_LOGO") {
          <div class="svg-image cursor-pointer" [innerHTML]="(userInformation | async)?.ApplicationInfo?.ApplicationHeaderLogoUrl | sanitizer: 'html'" (click)="onClickLogo()"></div>
        }
      }
    </div>
    <div class="right__content w-100">
      @if (themeSwitcherVisible) {
        <div id="svg-container" class="d-flex flex-row justify-content-center align-items-center pe-3">
          <div class="d-block cursor-pointer theme-icon-container">
            <svg
              id="svg1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              width="16px"
              height="16px"
              [ngClass]="{ 'd-none': globalService.currentTheme === 'white', animate: globalService.currentTheme === 'dark' }"
              (click)="onThemeChange('white')">
              <path
                d="M11.3807 2.01886C9.91573 3.38768 9 5.3369 9 7.49999C9 11.6421 12.3579 15 16.5 15C18.6631 15 20.6123 14.0843 21.9811 12.6193C21.6613 17.8537 17.3149 22 12 22C6.47715 22 2 17.5228 2 12C2 6.68514 6.14629 2.33869 11.3807 2.01886Z"></path>
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              width="16px"
              height="16px"
              [ngClass]="{ 'd-none': globalService.currentTheme === 'dark', animate: globalService.currentTheme === 'white' }"
              (click)="onThemeChange('dark')">
              <path
                d="M12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18ZM11 1H13V4H11V1ZM11 20H13V23H11V20ZM3.51472 4.92893L4.92893 3.51472L7.05025 5.63604L5.63604 7.05025L3.51472 4.92893ZM16.9497 18.364L18.364 16.9497L20.4853 19.0711L19.0711 20.4853L16.9497 18.364ZM19.0711 3.51472L20.4853 4.92893L18.364 7.05025L16.9497 5.63604L19.0711 3.51472ZM5.63604 16.9497L7.05025 18.364L4.92893 20.4853L3.51472 19.0711L5.63604 16.9497ZM23 11V13H20V11H23ZM4 11V13H1V11H4Z"></path>
            </svg>
          </div>
        </div>
      }

      @if (!externalMagicBellUserID && !isMagicBellVisible) {
        <mobi-office-lib-notification [externalUserID]="externalMagicBellUserID"></mobi-office-lib-notification>
      }
      @if (isProfileVisible) {
        <div
          #profilePopoverElement="ngbPopover"
          [ngbPopover]="profilePopover"
          [autoClose]="'outside'"
          popoverClass="header-profile-view-popover"
          class="profile-container border-one border-light-2-gray border-radius-10 px-2 py-1 d-flex align-items-center cursor-pointer">
          <img height="35" width="35" [src]="(userInformation | async)?.UserInfo?.UserLogoUrl" onerror="this.src = 'global-assets/mobi-office-ui/user-profile.png'" alt="Profile" />
          <p>{{ (userInformation | async)?.UserInfo?.Name }}</p>
        </div>
        <button class="d-none" id="close-profile-popover" (click)="profilePopoverElement.close()"></button>
      }
    </div>
  </div>
</div>
<ng-template #profilePopover>
  <div class="profile-popover-container">
    <div class="profile-logo d-flex flex-column align-items-center p-2">
      <img height="68" width="68" onerror="this.src = 'global-assets/mobi-office-ui/user-profile.png'" [src]="(userInformation | async)?.UserInfo?.UserLogoUrl" alt="Profile" />
      <span class="d-block text-dark-5-gray text-center fw-bold mt-1 user-name">{{ (userInformation | async)?.UserInfo?.Name }}</span>
      <span class="d-block text-dark-1-gray text-center email-id">{{ (userInformation | async)?.UserInfo?.EmailID }}</span>
    </div>
    @if ((userInformation | async)?.Roles) {
      <div class="d-flex px-2 pb-2 gap-1 flex-wrap justify-content-center">
        @for (item of (userInformation | async)?.Roles; track $index) {
          <mobi-office-lib-chips [chipText]="item.Name" [chipSize]="'small'"></mobi-office-lib-chips>
        }
      </div>
    }
    @if (isProfileSettingVisible || isLogOutVisible) {
      <div class="profile-details mt-2">
        <div class="menu-item" matRipple *ngIf="isProfileSettingVisible" (click)="UserSettingsDialog()">
          <span>Settings</span>
        </div>
        <div class="menu-item logout" matRipple *ngIf="isLogOutVisible" (click)="onLogOut()">
          <span>Logout</span>
        </div>
      </div>
    }
  </div>
</ng-template>
